import {RouteLocationNormalized} from 'vue-router'

/**
 * Whether a route is actually rendered as a stackable overlay.
 * A route may declare `meta.isStackable: true` statically but only behave as an
 * overlay when its `isStackableCondition` holds (e.g. a Conversation is only a
 * stackable overlay when opened with `?stackable=true`). Use this instead of the
 * raw `meta.isStackable` flag to avoid treating a normally-viewed resource as an overlay.
 */
export function isStackableRoute(route: RouteLocationNormalized | null | undefined): boolean {
  if(!route?.meta?.isStackable) {
    return false
  }
  if(typeof route.meta?.isStackableCondition === 'function') {
    return Boolean(route.meta.isStackableCondition(route, route))
  }
  return true
}

export function isStackableOverlayNavigation(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  let isStackable = to.meta?.isStackable
  if(Boolean(isStackable) && typeof to.meta?.isStackableCondition === 'function') {
    isStackable = to.meta.isStackableCondition(to, from)
  }
  const fromIsRealRoute = (from?.matched?.length ?? 0) > 0
  return Boolean(isStackable) && fromIsRealRoute
}
